import SettingsView from "./SettingsView.vue"
import GroupSettingsView from "../group/GroupSettingsView.vue"

const base = "/settings"

export default [
    {
        path: base,
        name: "settingsview",
        component: SettingsView
    },
    {
        path: base + "/groups",
        name: "groupsettingsview",
        component: GroupSettingsView
    }
]
